// Menu ids the app treats specially. These are menu_items.legacy_id values.

// Categories hidden from independent-living residents (?IL=true).
export const IL_HIDDEN_CATEGORY_IDS = [4, 5, 6];

// The Movies category. Its genres come from movie_genres, not menu_items.
export const MOVIES_CATEGORY_ID = 7;

// Virtual "Recently Added" genre: movies with is_recently_added, not a genre row.
export const RECENTLY_ADDED_GENRE_ID = 99;
